// src/store/category.js

import { defineStore } from 'pinia';
import { http } from './https';
import { LOCAL } from '@/constants';

export const useHomeStore = defineStore('home', {
    state: () => ({
        categoriesGames: {},
        sliders: [],
        categories: [],
        lang: localStorage.getItem(LOCAL) || "ar",
        searchGames: [],
        games: [],
        leaderboard: [],
        newGames: [],
        mostViews: [],
        mostRated: [],
        mostCommented: [],
        theme: 'light',
    }),
    getters: {
        getCategories: (state) => state.categories,
        getCategoriesGames: (state) => state.categoriesGames,
        getLeaderboard: (state) => state.leaderboard,
    },
    actions: {
        async fetchHomePageData() {
            try {
                this.categoriesGames = [];
                this.sliders = [];
                this.categories = [];
                this.newGames = [];
                this.mostViews = [];
                this.mostRated = [];
                this.mostCommented = [];

                const response = await http.get('/home?lang='+this.lang);
                const data = response.data;

                // Filter out categories with no games and then map over the remaining categories
                this.categoriesGames = data.categoriesWithGames
                    .filter(category => category.games && category.games.length > 0) // Filter out empty categories
                    .map(category => ({
                        ...category,
                        games: category.games.slice(0, 6) // Take only the first 6 games
                    }));

                this.sliders = data.sliders;
                this.categories = data.categories.filter(category => category.games && category.games.length > 0); // Also filter the main categories if needed
                // store categories in localStorage
                localStorage.setItem('categories', JSON.stringify(data.categories));
                this.newGames = data.new_games;
                this.mostViews = data.most_views;
                this.mostRated = data.most_rated;
                this.mostCommented = data.most_commented;
                // , , , 
            } catch (error) {
                console.error(error);
            }
        },
        async fetchLeaderboard() {
            try {
                const response = await http.get('/leaderboard');
                this.leaderboard = response.data.leaderboard;
            } catch (error) {
                console.error(error);
            }
        },
        async fetchConfigData() {
            const currentTime = new Date().getTime();
        
            const storedConfig = localStorage.getItem('config');
            const storedTimestamp = localStorage.getItem('config_timestamp');
        
            if (storedConfig && storedTimestamp && (currentTime - storedTimestamp) < (1000 * 60 * 60 * 24)) {
                return "config-exist";
            }
        
            try {
                const response = await http.get('/config');
                const data = response.data;
        
                if (data.status) {
                    localStorage.setItem('config', JSON.stringify(data.product));
                    localStorage.setItem('config_timestamp', currentTime.toString());  // Save the current timestamp
                    return "config-loaded";
                }
            } catch (error) {
                console.error(error);
            }
        
            return "config-missing";
        },
        toggleTheme() {
            this.theme = this.theme === 'light' ? 'dark' : 'light';
            document.documentElement.setAttribute('data-theme', this.theme);
            localStorage.setItem('theme', this.theme);
        },
        loadTheme() {
            const savedTheme = localStorage.getItem('theme');
            if (savedTheme) {
              this.theme = savedTheme;
            } else {
                // const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
                // this.theme = prefersDark ? 'dark' : 'light';
                this.theme = 'light';
            }
            document.documentElement.setAttribute('data-theme', this.theme);
        }
    },
});


